<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>语言学校</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="60px" size="small" class="query-form">
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="
            dialogVisible = true;
          form = { isEnable: true };
          areaSelectedOptions = [];
          stationOptions = [];
          simglist = [];
          bimglist = [];
          dormlist = [];
          conditlist = [];
          videolist = [];
          ">新增</el-button>
          <!-- <el-button type="warning" :loading="importing" @click="importIntroLabelClick">导入简介/标签</el-button>
          <div id="schoolIntroLabelUpload" style="display:none"></div> -->
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>语言学校</span>
        </div>
        <!-- 列表定义 -->
        <el-table v-loading="loading" :data="tableData" ref="tableData" border stripe style="width: 100%">
          <el-table-column prop="name" label="名称"></el-table-column>
          <!-- <el-table-column prop="oneWord" label="评语"></el-table-column> -->
          <el-table-column label="地区">
            <template slot-scope="scope">
              {{ scope.row.province }} {{ scope.row.city }}
            </template>
          </el-table-column>
          <el-table-column prop="studyFee" label="学费(万日元)"></el-table-column>
          <el-table-column prop="nature" label="学校性质"></el-table-column>
          <el-table-column prop="viewCount" label="浏览量"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column prop="isEnable" label="是否展示">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.isEnable == true">是</el-tag>
              <el-tag type="warn" v-else>否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="添加时间"></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="editClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button type="warning" size="mini" icon="el-icon-delete" @click="delClick(scope.row)"></el-button>
                </el-tooltip>
                <el-tooltip content="学校新闻" placement="top">
                  <el-link :href="'./schoolnews?id=' + scope.row.id" target="_blank">
                    <el-button type="success" size="mini" icon="el-icon-news"></el-button>
                  </el-link>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog title="导入结果" :visible.sync="importResultVisible" width="560px">
      <p style="margin-bottom:12px;line-height:1.6">{{ importResult.summary }}</p>
      <div v-if="importResult.notFoundNames && importResult.notFoundNames.length" style="margin-bottom:10px">
        <div style="font-weight:600;margin-bottom:4px">未匹配学校（{{ importResult.notFoundNames.length }}）</div>
        <div style="max-height:120px;overflow:auto;color:#909399;font-size:13px">{{ importResult.notFoundNames.join('、') }}</div>
      </div>
      <div v-if="importResult.duplicateNames && importResult.duplicateNames.length" style="margin-bottom:10px">
        <div style="font-weight:600;margin-bottom:4px">重名跳过（{{ importResult.duplicateNames.length }}）</div>
        <div style="max-height:80px;overflow:auto;color:#E6A23C;font-size:13px">{{ importResult.duplicateNames.join('、') }}</div>
      </div>
      <div v-if="importResult.errors && importResult.errors.length">
        <div style="font-weight:600;margin-bottom:4px">错误</div>
        <div style="max-height:100px;overflow:auto;color:#F56C6C;font-size:13px">
          <div v-for="(e, i) in importResult.errors" :key="i">{{ e }}</div>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="importResultVisible = false">知道了</el-button>
      </span>
    </el-dialog>

    <!-- 操作对话框 form表单对应编辑，弹出对话框-->
    <el-dialog :title="form.id > 0 ? '编辑语言学校' : '添加语言学校'" :visible.sync="dialogVisible" @opened="dialogOpened()">
      <el-form :model="form" ref="form" label-width="100px" :status-icon="true"
        @submit.native.prevent="submitForm('form')">
        <el-tabs type="card">
          <el-tab-pane label="基本信息">
            <el-form-item label="名称" prop="name" :rules="[{ required: true, message: '请输入学校名称' }]">
              <el-input v-model="form.name" placeholder="请输入学校名称"></el-input>
            </el-form-item>
            <!-- 列表展示图 -->
            <el-form-item label="列表图" prop="imgUrl" :rules="[{ required: true, message: '不能为空' }]">
              <div id="uploadBtn6" class="uploader uploader-warning"></div>
              <img id="relativeName" :src="domain + form.imgUrl"
                style="width: 40px; height: 40px; position: relative; left: 10px; top: 20px" v-if="form.imgUrl" />
              <span class="imgtext" title type="info"
                style="position: relative; left: 0px; top: 1px">*列表页展示，推荐400*400</span>
            </el-form-item>
            <!-- 详情页头图（可单独上传；未上传时小程序回退列表图） -->
            <el-form-item label="详情头图" prop="detailImgUrl">
              <div id="uploadBtnDetailImg" class="uploader uploader-warning"></div>
              <img v-if="form.detailImgUrl" :src="domain + form.detailImgUrl"
                style="width: 60px; height: 60px; object-fit: cover; position: relative; left: 10px; top: 20px" />
              <el-button v-if="form.detailImgUrl" type="text" style="margin-left: 8px;"
                @click="form.detailImgUrl = ''">删除</el-button>
              <span class="imgtext" title type="info"
                style="position: relative; left: 0px; top: 1px">*详情页顶部大图，建议接近正方形、宽≥750；选图后直接上传，不传则用列表图</span>
            </el-form-item>
            <el-form-item label="视频地址">
              <div id="uploadBtn7" class="uploader uploader-warning"></div>
              <!-- v-for="(item,index) in videolist" :key="index" -->
              <div id="relativeName" style="margin-left: 20px" v-for="(item, index) in videolist" :key="index">
                <a :href="addDomainIfNeeded(item)" target="_blank">{{ addDomainIfNeeded(item) }}</a>
                <span style="color:red;font-size: 12px;padding-left: 10px;" @click="delhref(index)">删除</span>
              </div>
              <!-- <span
                class="imgtext"
                title
                type="info"
                style="position: relative; left: 0px; top: 1px"
                >*视频格式：mp4;视频最大不超过1G；</span
              > -->
            </el-form-item>


            <!-- 选择地区 -->
            <el-form-item label="地区" :rules="[{ required: true, message: '不能为空' }]">
              <el-cascader :options="japanAreaTree" v-model="areaSelectedOptions" clearable
                :props="{ value: 'areaID', label: 'areaName', children: 'children', checkStrictly: true }" style="width: 100%"
                placeholder="请选择地区（大区/市，区可选）"></el-cascader>
            </el-form-item>

            <el-form-item label="附近车站">
              <el-select
                v-model="stationOptions"
                multiple
                filterable
                clearable
                placeholder="请选择附近车站（可多选）"
                style="width: 100%"
              >
                <el-option
                  v-for="item in stationList"
                  :key="item.id || item.name"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
              <div style="color:#909399;font-size:12px;line-height:1.4;margin-top:4px;">
                选项来自「基础数据 → 热门车站」，与小程序选校页车站筛选一致
              </div>
            </el-form-item>

            <el-form-item label="学校地址" prop="siteDetail" :rules="[{ required: true, message: '不能为空' }]">
              <el-input v-model="form.siteDetail" placeholder="请输入学校地址"></el-input>
            </el-form-item>

            <!-- 小程序暂无地图，暂隐藏选点
            <el-row :gutter="24">
              <el-col :span="10">
                <el-form-item label="经度" prop="longitude">
                  <el-input v-model="form.longitude" placeholder="地图选点自动填充"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="纬度" prop="latitude">
                  <el-input v-model="form.latitude" placeholder="地图选点自动填充"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button type="success" @click="dialogMap = true">选择位置</el-button>
              </el-col>
            </el-row>
            -->

            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="学费" prop="studyFee" :rules="[{ required: true, message: '不能为空' }]">
                  <el-input type="number" step="0.01" v-model="form.studyFee" placeholder="请输入学费">
                    <template slot="append">万日元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="学费2" prop="studyFeeT">
                  <el-input type="number" step="0.01" v-model="form.studyFeeT" placeholder="请输入学费2">
                    <template slot="append">万日元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="建校时间" prop="foundYear" :rules="[{ required: true, message: '不能为空' }]">
                  <el-input v-model.number="form.foundYear" placeholder="请输入建校时间">
                    <template slot="append">年</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="学校性质" prop="nature" :rules="[{ required: true, message: '不能为空' }]">
                  <el-select v-model="form.nature" placeholder="请选择学校性质" filterable style="width: 100%">
                    <el-option v-for="item in naturelist" :label="item.name" :value="item.name"
                      :key="item.name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="定员" prop="fixedCount" :rules="[{ required: true, message: '不能为空' }]"
                  style="width: 100%">
                  <el-input v-model.number="form.fixedCount" placeholder="请输入定员">
                    <template slot="append">人</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="学生比例" prop="chinesePercent">
                  <el-input v-model.number="form.chinesePercent" placeholder="请输入中国学生比例">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="入学时间" prop="monthList">
                  <el-select v-model="form.monthList" placeholder="请选择入学时间" filterable multiple style="width: 100%">
                    <el-option v-for="item in monthlist" :label="item.name" :value="item.id" :key="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 学校标签：有二级选二级；仅一级时也可直接选一级名称 -->
            <el-form-item label="学校标签" prop="labelList">
              <el-select
                v-model="form.labelList"
                placeholder="请选择标签（无二级的一级分类也可直接选）"
                clearable
                filterable
                multiple
                style="width: calc(100% - 90px)"
              >
                <el-option-group
                  v-for="group in labelTree"
                  :key="group.id"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.children"
                    :key="item.id"
                    :label="item.label"
                    :value="item.label"
                  ></el-option>
                </el-option-group>
              </el-select>
              <router-link to="/schoolLabel" target="_blank" style="margin-left: 10px">
                <el-button type="text">标签管理</el-button>
              </router-link>
            </el-form-item>
            <!-- 学校标签底部 -->
            <el-form-item label="评语" prop="oneWord">
              <el-input v-model="form.oneWord" placeholder="请输入评语"></el-input>
            </el-form-item>

            <el-form-item label="学校周边" prop="ambitus">
              <el-input type="textarea" v-model="form.ambitus" placeholder="请输入学校周边"></el-input>
            </el-form-item>

            <el-form-item label="地图交通" prop="siteMap">
              <el-input type="textarea" v-model="form.siteMap" placeholder="请输入地图交通"></el-input>
            </el-form-item>

            <el-form-item label="排序字段" prop="sort">
              <el-input v-model.number="form.sort" placeholder="请输入排序字段"></el-input>
            </el-form-item>
            <!-- 是否可用顶部 -->
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item prop="isEnable" label="是否可用" :rules="[{ required: true, message: '不能为空' }]">
                  <el-switch v-model="form.isEnable"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>

          <!-- 学校组图 -->
          <el-tab-pane label="学校组图">
            <div class="uploader uploader-warning" id="uploadSchool1"></div>
            <el-row>
              <el-col :span="6" v-for="(item, index) in simglist" :key="index" style="padding: 5px">
                <el-card :body-style="{ padding: '0px' }">
                  <el-image :src="item" class="image" style="width: 100%; height: 100px"
                    :preview-src-list="bimglist"></el-image>
                  <!-- <img
                    :src="item"
                    class="image"
                    style="width: 100%"
                    :preview-src-list="bimglist"
                  /> -->
                  <div style="padding: 5px 14px 10px 14px">
                    <div class="bottom clearfix">
                      <el-button-group>
                        <el-tooltip content="前移" placement="top">
                          <el-button type="primary" icon="el-icon-arrow-left" size="mini"
                            @click="imgMove(index)"></el-button>
                        </el-tooltip>
                        <el-tooltip content="删除" placement="top">
                          <el-button type="danger" icon="el-icon-delete" size="mini"
                            @click="imgRemove(index)"></el-button>
                        </el-tooltip>
                      </el-button-group>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <div style="height: 10px"></div>
            <el-alert style="margin-bottom: 10px">
              <p>说明：上传图片宽度不小于500，上传图片数量不超过15张</p>
            </el-alert>
          </el-tab-pane>

          <!-- 720VR探校链接（业务域名固定，只填路径） -->
          <el-tab-pane label="720VR探校">
            <el-form-item label="720链接" prop="vrImgBigList">
              <el-input
                v-model="form.vrImgBigList"
                placeholder="/vr/eacjepeuOy1?s=31874747"
                clearable
              >
                <template slot="prepend">{{ vr720Host }}</template>
              </el-input>
            </el-form-item>
            <el-form-item label="VR缩略图" prop="vrImgSmallList">
              <div id="uploadBtnVrThumb" class="uploader uploader-warning"></div>
              <img
                v-if="form.vrImgSmallList && form.vrImgSmallList !== '1'"
                :src="domain + form.vrImgSmallList"
                style="width: 120px; height: 68px; object-fit: cover; margin-left: 10px; vertical-align: top; border-radius: 4px;"
              />
              <el-button
                v-if="form.vrImgSmallList && form.vrImgSmallList !== '1'"
                type="text"
                style="margin-left: 8px;"
                @click="form.vrImgSmallList = ''"
              >删除</el-button>
            </el-form-item>
            <el-alert style="margin-bottom: 10px" type="info" :closable="false">
              <p>说明：720链接填路径即可。缩略图用于详情页 VR 预览，建议 16:9，宽不小于 750px。</p>
            </el-alert>
          </el-tab-pane>
          <!-- 学习介绍字段  -->
          <el-tab-pane label="学校介绍">
            <el-form-item label="学校介绍" prop="summary">
              <div style="position: relative">
                <vue-ueditor-wrap v-model="form.summary" :config="editorConfig"></vue-ueditor-wrap>
              </div>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="官方简介">
            <el-form-item label="官方简介" prop="special">
              <div style="position: relative">
                <div class="btn-my">
                  <el-button size="mini" type="success" @click="addTitle()">自定义标题</el-button>
                </div>
                <vue-ueditor-wrap v-model="form.special" :config="editorConfig" @ready="editorReady"></vue-ueditor-wrap>
              </div>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="学生反馈">
            <el-form-item label="学生反馈" prop="feedBack">
              <div style="position: relative">
                <vue-ueditor-wrap v-model="form.feedBack" :config="editorConfig"></vue-ueditor-wrap>
              </div>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="申请条件">
            <el-button type="primary" @click="
              dialogCondition = true;
            conditParam = {};
            ">添加</el-button>
            <table class="el-table" style="margin: 20px 0px">
              <tr>
                <th class="cell" border="1">类型</th>
                <th class="cell">操作</th>
              </tr>
              <tr v-for="(item, index) in conditlist" :key="item.key">
                <td class="cell">{{ item.name }}</td>
                <td class="cell">
                  <el-button-group>
                    <el-tooltip content="编辑" placement="top">
                      <el-button type="primary" size="mini" icon="el-icon-edit"
                        @click="editConditParam(index)"></el-button>
                    </el-tooltip>
                    <el-tooltip content="移动" placement="top">
                      <el-button type="success" size="mini" icon="el-icon-arrow-up"
                        @click="moveConditParam(index)"></el-button>
                    </el-tooltip>
                    <el-tooltip content="删除" placement="top">
                      <el-button type="warning" size="mini" icon="el-icon-delete"
                        @click="delConditParam(index)"></el-button>
                    </el-tooltip>
                  </el-button-group>
                </td>
              </tr>
            </table>
          </el-tab-pane>
          <el-tab-pane label="宿舍介绍">
            <el-button type="primary" @click="
              dialogDorm = true;
            param = {};
            ">添加</el-button>
            <table class="el-table" style="margin: 20px 0px">
              <tr>
                <th class="cell" border="1">类型</th>
                <th class="cell">价格</th>
                <th class="cell">周期</th>
                <th class="cell">图片</th>
                <th class="cell">操作</th>
              </tr>
              <tr v-for="(item, index) in dormlist" :key="item.key">
                <td class="cell">{{ item.type }}</td>
                <td class="cell">{{ item.price }}</td>
                <td class="cell">{{ item.time }}</td>
                <td class="cell">
                  <el-image style="width: 75px" :src="domain + item.imgUrl"
                    :preview-src-list="[domain + item.imgUrl]"></el-image>
                </td>
                <td class="cell">
                  <el-button-group>
                    <el-tooltip content="编辑" placement="top">
                      <el-button type="primary" size="mini" icon="el-icon-edit" @click="editParam(index)"></el-button>
                    </el-tooltip>
                    <el-tooltip content="移动" placement="top">
                      <el-button type="success" size="mini" icon="el-icon-arrow-up"
                        @click="moveParam(index)"></el-button>
                    </el-tooltip>
                    <el-tooltip content="删除" placement="top">
                      <el-button type="warning" size="mini" icon="el-icon-delete" @click="delParam(index)"></el-button>
                    </el-tooltip>
                  </el-button-group>
                </td>
              </tr>
            </table>
          </el-tab-pane>
        </el-tabs>
        <!-- 提交事件按钮  -->
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false;  videolist = [];">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 小程序暂无地图，暂隐藏选点
    <el-dialog title="地图选点" :visible.sync="dialogMap" @opened="dialogMapOpen()" @close="destroyMap">
      <el-form label-width="100px">
        <el-form-item label="搜索地址：">
          <el-input v-model="searchKey" placeholder="日文地址更准，如：東京都新宿区2丁目2-12">
            <el-button type="primary" slot="append" icon="el-icon-search" :loading="mapSearching" @click="searchMap()">搜索</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div id="mapContainer" class="osm-map"></div>
      <div class="dialog-footer" slot="footer">
        <el-button type="success" @click="yesClickMap">确定</el-button>
        <el-button @click="dialogMap = false">取消</el-button>
      </div>
    </el-dialog>
    -->

    <!-- 宿舍 -->
    <el-dialog :title="form.id > 0 ? '编辑宿舍' : '添加宿舍'" :visible.sync="dialogDorm" @opened="dialogOpened1()">
      <el-form :model="param" ref="param" label-width="110px" :status-icon="true"
        @submit.native.prevent="submitParam(param)">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item prop="type" label="类型" :rules="[{ required: true, message: '不能为空' }]">
              <el-select v-model="param.type" placeholder="请选择宿舍类型" clearable>
                <el-option v-for="item in dormtypelist" :key="item.id" :value="item.name"
                  :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="price" label="价格" :rules="[{ required: true, message: '不能为空' }]">
              <el-input step="0.01" v-model="param.price" placeholder="请输入价格"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="图片" :rules="[{ required: true, message: '不能为空' }]">
          <div id="uploadBtn9" class="uploader uploader-warning"></div>
          <img id="relativeName" :src="domain + param.imgUrl"
            style="height: 40px; position: relative; left: 10px; top: 20px" v-if="param.imgUrl" />
        </el-form-item>

        <el-form-item label="周期" prop="time" :rules="[{ required: true, message: '不能为空' }]">
          <el-input v-model="param.time" placeholder="请输入周期"></el-input>
        </el-form-item>

        <el-form-item label="费用详情" prop="feeList" :rules="[{ required: true, message: '不能为空' }]">
          <el-input type="textarea" :rows="4" v-model="param.feeList" placeholder="请输入费用详情，换行隔开"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogDorm = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 申请条件 -->
    <el-dialog :title="form.id > 0 ? '编辑申请条件' : '添加申请条件'" :visible.sync="dialogCondition">
      <el-form :model="conditParam" ref="conditParam" label-width="110px" :status-icon="true"
        @submit.native.prevent="submitConditParam(conditParam)">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item prop="name" label="类型" :rules="[{ required: true, message: '不能为空' }]">
              <el-select v-model="conditParam.name" placeholder="请选择类型" clearable>
                <el-option v-for="item in condittypelist" :key="item.id" :value="item.name"
                  :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="条件内容" prop="content">
          <el-input type="textarea" :rows="4" v-model="conditParam.content" placeholder="请输入条件内容"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogCondition = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import VueUeditorWrap from "vue-ueditor-wrap";
var editorInstance = null;
export default {
  components: { VueUeditorWrap },
  name: 'shool',
  data() {
    return {
      editorConfig: {
        initialFrameHeight: 500, //设置高度
        initialFrameWidth: "100%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE(),
      },
      domain: url.getDomain(),
      /** 720云小程序业务域名（web-view 校验域名） */
      vr720Host: "https://f5fz3e7z2re.720yun.com",
      query: {}, //对象
      param: {}, //宿舍对象
      conditParam: {}, //申请条件对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      dialogDorm: false,
      dialogCondition: false,
      japanAreaTree: [],
      areaSelectedOptions: [],
      stationOptions: [],
      stationList: [], // 附近车站下拉选项（热门车站 + 已用车站）
      naturelist: [], //学校性质
      labellist: [], // 兼容旧逻辑
      labelTree: [], // 两级标签树 Model 12
      monthlist: [], //入学时间
      simglist: [], //小图
      bimglist: [], //大图
      dormlist: [], //宿舍列表
      dormtypelist: [], //宿舍类型
      condittypelist: [], //申请条件类型
      conditlist: [], //申请条件
      // dialogMap: false,
      // searchKey: "",
      // mapSearching: false,
      // leafletMap: null,
      // leafletMarker: null,
      // latLng: { lat: 35.6812, lng: 139.7671 },
      videolist: [],
      componentKey: 0,
      importing: false,
      importResultVisible: false,
      importResult: {
        summary: "",
        notFoundNames: [],
        duplicateNames: [],
        errors: []
      }
    };
  },
  methods: {
    importIntroLabelClick() {
      var _this = this;
      this.$confirm(
        "请上传 Excel（列：学校名称、简介、班型特色、性价比、学生构成、学校规模、兴趣标签）。按学校名称匹配语言学校，覆盖「学校介绍」与「学校标签」。",
        "导入简介/标签",
        { confirmButtonText: "选择文件", cancelButtonText: "取消", type: "warning" }
      ).then(function () {
        _this.initIntroLabelUploader();
        $("#schoolIntroLabelUpload input[type=file]").val("").click();
      }).catch(function () {});
    },
    initIntroLabelUploader() {
      if ($("#schoolIntroLabelUpload input[type=file]").length > 0) return;
      var _this = this;
      $("#schoolIntroLabelUpload").uploader({
        url: url.getUpload(),
        fileExts: "xlsx;xls",
        text: "导入简介标签",
        more: false,
        auto: true,
        isImg: false,
        handleType: "0",
        onSuccess: function (data) {
          var filePath = (data && data.relativeName) || "";
          if (!filePath) {
            _this.showImportResult({
              summary: "上传失败，未返回文件地址",
              notFoundNames: [],
              duplicateNames: [],
              errors: []
            });
            return;
          }
          _this.doImportIntroLabel(filePath);
        }
      });
    },
    doImportIntroLabel(filePath) {
      var _this = this;
      _this.importing = true;
      var loading = _this.$loading({ lock: true, text: "正在导入，请稍候…" });
      $.post(url.getSchool("Import_IntroLabel"), { filePath: filePath }, function (res) {
        _this.importing = false;
        loading.close();
        if (!res || res.status == 0 || res.status === false) {
          _this.showImportResult({
            summary: (res && (res.msg || res.innerMsg)) || "导入失败",
            notFoundNames: [],
            duplicateNames: [],
            errors: []
          });
          return;
        }
        var data = res.data || {};
        _this.showImportResult({
          summary: res.msg || "导入完成",
          notFoundNames: data.notFoundNames || [],
          duplicateNames: data.duplicateNames || [],
          errors: data.errors || []
        });
        _this.selList();
      })
    },
    showImportResult(result) {
      this.importResult = result || {
        summary: "",
        notFoundNames: [],
        duplicateNames: [],
        errors: []
      };
      this.importResultVisible = true;
    },
    addDomainIfNeeded(item) {
      // 如果链接不包含 'http'，则添加域名
      if (!item.includes('http')) {
        console.log('123', `${this.domain}${item}`);
        // this.updateComponent();
        return `${this.domain}${item}`;

      }
      return item;
    },

    /** 输入/回显：只保留 720 路径（/vr/... 或 /t/...） */
    toVrPath(val) {
      if (!val) return "";
      var s = String(val).trim();
      if (!s || s.indexOf(",") >= 0) return "";
      s = s.replace(/^https?:\/\/(www\.)?720yun\.com/i, "");
      s = s.replace(/^https?:\/\/f5fz3e7z2re\.720yun\.com/i, "");
      if (!s) return "";
      if (s.charAt(0) !== "/") s = "/" + s;
      return s;
    },

    delhref(index) {
      this.videolist.splice(index, 1);
      this.updateComponent();
      this.$message({
        message: '删除成功',
        type: 'warning'
      });
    },
    editorReady(instance) {
      editorInstance = instance;
    },
    //添加标题
    addTitle() {
      var title = '<h3 style="box-sizing: border-box; margin-top: 0px; margin-right: 0px; margin-left: 0px; line-height: 16px; font-family: &quot;Microsoft YaHei,Arial,Helvetica,sans-serif&quot;; white-space: normal; background-color: rgb(255, 255, 255); margin-bottom: 10px !important; color: rgb(56, 57, 56) !important; font-size: 16px !important; border-bottom: 1px solid rgb(217, 217, 217) !important;"><strong style="box-sizing: border-box; display: inline-block; padding: 14px 0px; border-bottom: 2px solid rgb(46, 174, 240); margin-bottom: -1px;">标题内容</strong></h3>';


      title = editorInstance.getContent() + title;

      editorInstance.setContent(title);
      editorInstance.focus();
    },
    //删除上传的视频
    delidx(index) {
      this.videoUrlsArray.splice(index, 1);
      $message({
        type: 'success',
        message: '删除成功'
      })
      this.updateComponent();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    // 获取学校性质
    getSchNature: function () {
      var _this = this;
      var link = url.getSchool("getschnature");
      $.get(link, {}, (data) => {
        _this.naturelist = data;
      });
    },
    // 获取筛选标签（Model 5）：有二级则分组；无二级的一级分类可直接选为学校标签
    getSchLabelList: function () {
      var _this = this;
      var link = url.getSys_BasicData("GetBaseTree");
      $.get(link, { modelid: 5 }, function (data) {
        var groups = [];
        var flat = [];
        (data || []).forEach(function (p) {
          if (p.children && p.children.length) {
            groups.push({ id: p.id, label: p.label, children: p.children });
          } else {
            // 只有一级、没有二级：一级名称本身可作为学校标签
            flat.push({ id: p.id, label: p.label });
          }
        });
        if (flat.length) {
          groups.unshift({ id: 0, label: "一级分类（可直接选）", children: flat });
        }
        _this.labelTree = groups;
      });
    },
    //获取入学时间
    getMonthList: function () {
      var _this = this;
      var link = url.getSchool("GetMonthList");
      $.get(link, {}, (data) => {
        _this.monthlist = data;
      });
    },
    // 获取地区
    getJapAreaList: function () {
      var _this = this;
      var link = url.getCommon("getarea_Japan");
      $.get(link, {}, (data) => {
        _this.japanAreaTree = data;
      });
    },
    // 附近车站下拉（热门车站 + 学校已用车站）
    getStationList: function () {
      var _this = this;
      $.get(url.getSchool("GetStationOptions"), {}, function (data) {
        _this.stationList = data || [];
      });
    },
    /** 编辑回显时，把已选但不在下拉里的车站补进选项 */
    ensureStationOptions: function (selected) {
      var list = this.stationList ? this.stationList.slice() : [];
      var exist = {};
      list.forEach(function (item) {
        if (item && item.name) exist[item.name] = true;
      });
      (selected || []).forEach(function (name) {
        if (name && !exist[name]) {
          list.push({ id: name, name: name });
          exist[name] = true;
        }
      });
      this.stationList = list;
    },
    findAreaPath(tree, areaID, path) {
      if (!areaID || !tree) return [];
      path = path || [];
      for (var i = 0; i < tree.length; i++) {
        var node = tree[i];
        var currentPath = path.concat([node.areaID]);
        if (node.areaID === areaID) return currentPath;
        if (node.children && node.children.length) {
          var found = this.findAreaPath(node.children, areaID, currentPath);
          if (found.length) return found;
        }
      }
      return [];
    },
    findAreaLabels(tree, pathIds) {
      var labels = [];
      var nodes = tree || [];
      for (var i = 0; i < (pathIds || []).length; i++) {
        var found = null;
        for (var j = 0; j < nodes.length; j++) {
          if (nodes[j].areaID === pathIds[i]) {
            found = nodes[j];
            break;
          }
        }
        if (!found) break;
        labels.push(found.areaName);
        nodes = found.children || [];
      }
      return labels;
    },
    matchAreaFromAddress(address) {
      if (!address || !this.japanAreaTree.length) return;
      var text = address
        .replace(/東京都/g, "东京都")
        .replace(/大阪府/g, "大阪府");
      var tokyo = null;
      var osaka = null;
      for (var i = 0; i < this.japanAreaTree.length; i++) {
        var region = this.japanAreaTree[i];
        if (!region.children) continue;
        for (var j = 0; j < region.children.length; j++) {
          if (region.children[j].areaID === 3858) tokyo = region.children[j];
          if (region.children[j].areaID === 3873) osaka = region.children[j];
        }
      }
      var targets = [];
      if (tokyo && tokyo.children) targets = targets.concat(tokyo.children);
      if (osaka && osaka.children) targets = targets.concat(osaka.children);
      for (var k = 0; k < targets.length; k++) {
        if (text.indexOf(targets[k].areaName) >= 0) {
          var path = this.findAreaPath(this.japanAreaTree, targets[k].areaID);
          if (path.length) this.areaSelectedOptions = path;
          return;
        }
      }
    },
    // 获取语言学校宿舍类型
    getSchDormTypeList: function () {
      var _this = this;
      var link = url.getSchool("GetDormType");
      $.get(link, {}, (data) => {
        _this.dormtypelist = data;
      });
    },
    //获取语言学校申请条件类型
    getSchConditionType() {
      var _this = this;
      var link = url.getSchool("GetSchoolConditionType");
      $.get(link, {}, (data) => {
        _this.condittypelist = data;
      });
    },
    //查询列表
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.type = 1;
      var link = url.getSchool("getlist_school");

      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    // 上传
    dialogOpened: function () {
      var _this = this;

      // 上传列表图
      if ($("#uploadBtn6 input").length == 0) {
        $("#uploadBtn6").uploader({
          url: url.getUpload(),
          text: "上传列表图",
          fileExts: "jpg;png",
          type: "dialog",
          coverParams: {
            targetWidth: 400,
            targetHeight: 400,
            // itemWidth: 700,
            // itemheight:500,
          },
          maxSize: 1024 * 1024 * 1,
          onSuccess: function (data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "imgUrl", data.relativeName);
          },
        });
      }

      // 上传详情头图（直接上传，不弹裁剪选框）
      if ($("#uploadBtnDetailImg input").length == 0) {
        $("#uploadBtnDetailImg").uploader({
          url: url.getUpload(),
          text: "上传详情头图",
          type: "single",
          fileExts: "jpg;png",
          maxSize: 1024 * 1024 * 2,
          onSuccess: function (data) {
            _this.$set(_this.form, "detailImgUrl", data.relativeName);
          },
        });
      }

      if ($("#uploadBtnVrThumb input").length == 0) {
        $("#uploadBtnVrThumb").uploader({
          url: url.getUpload(),
          text: "上传缩略图",
          type: "single",
          fileExts: "jpg;png",
          maxSize: 1024 * 1024 * 2,
          onSuccess: function (data) {
            _this.$set(_this.form, "vrImgSmallList", data.relativeName);
          },
        });
      }

      // 上传视频

      $("#uploadBtn7").uploader({
        text: "上传视频",
        type: 'single',
        fileExts: "mp4",
        uploadType: 3,
        debug: true,
        maxSize: 1024 * 1024 * 1024, //上传文件最大值
        //开始上传验证扩展
        onSuccess: function (data) {
          console.log('data:', data);
          var relativeName1 = data.absoluteName; //解决其他js时间中的vue数据同步问题
          _this.videolist.push(data.absoluteName);
          console.log('_this.videolist:', _this.videolist);
          //  _this.$set(_this.form, "videoUrl", relativeName1);
        },
      });


      //   上传大小图
      if ($("#uploadSchool1 input").length == 0) {
        $("#uploadSchool1").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          more: true, //是否可以上传多个
          auto: true, //是否自动上传
          type: "imgdouble",
          minWidth: 600,
          minHeight: 600,
          maxWidth: 1200,
          maxHeight: 1200,
          handleType: "0", //对于大小图模式最好不要自动处理
          maxSize: 1024 * 1024 * 1,
          onSuccess: function (data) {
            var small = data.small;
            var big = data.big;
            //增加上传处理后台处理
            var data = {
              imgSmall: small.relativeName,
              imgBig: big.relativeName,
            };
            _this.simglist.push(_this.domain + data.imgSmall);
            _this.bimglist.push(_this.domain + data.imgBig);
          },
        });
      }

    },
    //编辑 函数
    editClick: function (row) {
      var _this = this;
      _this.dialogVisible = true;
      _this.videolist=[];
      var link = url.getSchool("getmodel_school");
      var id = row.id;
      $.get(link, { id: id }, (data) => {
        _this.areaSelectedOptions = _this.findAreaPath(_this.japanAreaTree, data.areaID);
        if (!_this.areaSelectedOptions.length && data.province && data.city) {
          var fallbackPath = [];
          for (var ri = 0; ri < _this.japanAreaTree.length; ri++) {
            var region = _this.japanAreaTree[ri];
            if (region.areaName === data.province && region.children) {
              fallbackPath.push(region.areaID);
              for (var pi = 0; pi < region.children.length; pi++) {
                if (region.children[pi].areaName === data.city) {
                  fallbackPath.push(region.children[pi].areaID);
                  break;
                }
              }
              break;
            }
          }
          _this.areaSelectedOptions = fallbackPath;
        }
        _this.stationOptions = data.stationList ? data.stationList.split(",").filter(function (s) { return s; }) : [];
        _this.ensureStationOptions(_this.stationOptions);
        if (data.monthList) {
          data.monthList = data.monthList.split(",");
        }
        if (data.labelList) {
          data.labelList = data.labelList.split(",");
        }
        if (data.imgSmallList) {
          _this.simglist = data.imgSmallList.split(",");
        }
        if (data.imgBigList) {
          _this.bimglist = data.imgBigList.split(",");
        }
        // vrImgBigList：编辑时只展示路径；旧组图（逗号）清空
        if (data.vrImgBigList && data.vrImgBigList.indexOf(",") >= 0) {
          data.vrImgBigList = "";
        } else {
          data.vrImgBigList = _this.toVrPath(data.vrImgBigList);
        }
        if (data.vrImgSmallList === '1') {
          data.vrImgSmallList = '';
        }
        if (data.dormContent) {
          _this.dormlist = JSON.parse(data.dormContent);
        } else {
          _this.dormlist = [];
        }
        if (data.condition) {
          _this.conditlist = JSON.parse(data.condition);
        } else {
          _this.dormlist = [];
        }
        _this.form = data;
        _this.videolist = data.videoUrl.split(',')
      });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      if (!_this.areaSelectedOptions || _this.areaSelectedOptions.length < 2) {
        _this.$message({
          type: "error",
          message: "请选择到市/都道府县",
        });
        return;
      }
      var link = url.getSchool("save_school");
      var info = this.form;
      info.videoUrl = this.videolist.join(',');
      console.log('info:', info);
      info.type = 1;
      var areaLabels = _this.findAreaLabels(_this.japanAreaTree, _this.areaSelectedOptions);
      info.province = areaLabels[0] || "";
      info.city = areaLabels[1] || "";
      if (_this.areaSelectedOptions && _this.areaSelectedOptions.length > 0) {
        info.areaID = _this.areaSelectedOptions[_this.areaSelectedOptions.length - 1];
      }
      if (_this.stationOptions && _this.stationOptions.length > 0) {
        info.stationList = _this.stationOptions.join(",");
      } else {
        info.stationList = "";
      }
      if (info.monthList) {
        info.monthList = info.monthList.toString();
      }
      if (_this.simglist) {
        info.imgSmallList = _this.simglist.toString();
      }
      if (_this.bimglist) {
        info.imgBigList = _this.bimglist.toString();
      }
      // 720VR：输入路径，入库完整业务域名链接
      var vrPath = _this.toVrPath(info.vrImgBigList);
      info.vrImgBigList = vrPath ? (_this.vr720Host + vrPath) : "";
      if (info.vrImgSmallList === '1') {
        info.vrImgSmallList = '';
      }
      if (info.labelList) {
        info.labelList = info.labelList.toString();
      }
      if (_this.dormlist) {
        info.dormContent = JSON.stringify(_this.dormlist);
      }
      if (_this.conditlist) {
        info.condition = JSON.stringify(_this.conditlist);
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.videolist=[];
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var id = row.id;
      var link = url.getSchool("delete_school"); //获取请求地址

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        concelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.videolist=[];
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    /* 小程序暂无地图，暂隐藏选点 - 地图代码 Leaflet + Esri
    destroyMap() {
      if (this.leafletMap) {
        this.leafletMap.remove();
        this.leafletMap = null;
        this.leafletMarker = null;
      }
    },
    dialogMapOpen() {
      var _this = this;
      this.$nextTick(function () {
        _this.initLeafletMap();
      });
    },
    initLeafletMap() {
      var _this = this;
      if (typeof L === "undefined") {
        _this.$message.error("地图组件加载失败，请刷新页面重试");
        return;
      }
      _this.destroyMap();
      var lat = parseFloat(_this.form.latitude);
      var lng = parseFloat(_this.form.longitude);
      if (isNaN(lat)) lat = 35.6812;
      if (isNaN(lng)) lng = 139.7671;
      var mapEl = document.getElementById("mapContainer");
      if (!mapEl) return;

      _this.leafletMap = L.map(mapEl).setView([lat, lng], 13);
      L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}", {
        maxZoom: 19,
        attribution: "Tiles &copy; Esri",
      }).addTo(_this.leafletMap);

      _this.leafletMarker = L.marker([lat, lng], { draggable: true }).addTo(_this.leafletMap);
      _this.latLng = { lat: lat, lng: lng };

      _this.leafletMarker.on("dragend", function (e) {
        var p = e.target.getLatLng();
        _this.latLng = { lat: p.lat, lng: p.lng };
      });
      _this.leafletMap.on("click", function (e) {
        _this.leafletMarker.setLatLng(e.latlng);
        _this.latLng = { lat: e.latlng.lat, lng: e.latlng.lng };
      });

      setTimeout(function () {
        if (_this.leafletMap) _this.leafletMap.invalidateSize();
      }, 200);

      _this.searchKey = _this.form.siteDetail || "";
      if (!_this.form.latitude && _this.searchKey) {
        setTimeout(function () {
          _this.searchMap();
        }, 500);
      }
    },
    geocodeSearch(query) {
      var q = (query || "").trim();
      if (!q) return $.Deferred().reject().promise();
      return $.get(url.getCommon("GeocodeSearch"), { q: q });
    },
    applyGeocodeResult(data) {
      if (!data || data.lat == null || data.lng == null) return;
      var lat = parseFloat(data.lat);
      var lng = parseFloat(data.lng);
      this.latLng = { lat: lat, lng: lng };
      if (this.leafletMap && this.leafletMarker) {
        this.leafletMap.setView([lat, lng], 15);
        this.leafletMarker.setLatLng([lat, lng]);
      }
      var text = [data.pref, data.city, data.address].filter(function (v) { return v; }).join(" ");
      if (text) this.matchAreaFromAddress(text);
    },
    yesClickMap() {
      var _this = this;
      if (!_this.latLng) {
        _this.$message.warning("请先在地图上选择位置");
        return;
      }
      var lat = _this.latLng.lat;
      var lng = _this.latLng.lng;
      _this.form.latitude = lat;
      _this.form.longitude = lng;
      _this.dialogMap = false;
    },
    searchMap() {
      var _this = this;
      var key = (_this.searchKey || "").trim();
      if (!key) {
        _this.$message.warning("请输入搜索地址");
        return;
      }
      _this.mapSearching = true;
      _this.geocodeSearch(key).done(function (res) {
        if (res.status && res.data) {
          _this.applyGeocodeResult(res.data);
        } else {
          _this.$message.warning(res.msg || "未找到相关地址，请使用日文地址或在地图上直接选点");
        }
      }).fail(function () {
        _this.$message.error("地址搜索失败，请直接在地图上点击选点");
      }).always(function () {
        _this.mapSearching = false;
      });
    },
    */

    /********************************* 学校组图 ********************************* */
    //移动
    imgMove(index) {
      var slist = Object.assign([], this.simglist);
      var blist = Object.assign([], this.bimglist);
      var sabove = index - 1;
      if (sabove == -1) {
        sabove = slist.length - 1;
      }
      var stemp = slist[index];
      slist[index] = slist[sabove];
      slist[sabove] = stemp;
      this.simglist = slist;

      var babove = index - 1;
      if (babove == -1) {
        sabove = slist.length - 1;
      }
      var btemp = blist[index];
      blist[index] = blist[babove];
      blist[babove] = btemp;
      this.bimglist = blist;
    },
    //删除
    imgRemove(index) {
      var _this = this;
      _this.simglist.splice(index, 1);
      _this.bimglist.splice(index, 1);
    },

    /********************************* 宿舍介绍 ********************************* */
    //编辑
    editParam(index) {
      var list = this.dormlist;

      var strList = [];
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        strList.push(item);
      }
      this.param = strList[index];
      this.dialogDorm = true;
    },
    //删除
    delParam(index) {
      var list = this.dormlist;
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //执行删除操作
          list = list.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //移动
    moveParam(index) {
      var list = Object.assign([], this.dormlist);
      var temp = list[index];
      var above = index - 1;
      if (above == -1) {
        above = list.length - 1;
      }
      list[index] = list[above];
      list[above] = temp;
      this.dormlist = list;
    },
    // 上传
    dialogOpened1: function () {
      var _this = this;

      // 上传图片
      if ($("#uploadBtn9 input").length == 0) {
        $("#uploadBtn9").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          type: "dialog",
          coverParams: {
            targetWidth: 300,
            targetHeight: 200,
          },
          maxSize: 1024 * 1024 * 1,
          onSuccess: function (data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.param, "imgUrl", data.relativeName);
          },
        });
      }
    },
    // /提交
    submitParam(form) {
      var _this = this;
      this.$refs.param.validate((valid) => {
        if (valid) {
          //添加到参数列表
          var result = Object.assign({}, _this.param);
          var list = _this.dormlist;
          var index = -1;
          for (var i = 0; i < list.length; i++) {
            if (_this.dormlist[i].type == result.type) {
              index = i;
            }
          }
          if (index == -1) {
            _this.dormlist.push(result);
          } else {
            _this.dormlist[index] = result;
          }
          _this.dialogDorm = false;
        } else {
          return false;
        }
      });
    },
    updateComponent() {
      this.componentKey += 1;
    },

    /********************************* 申请条件 ********************************* */
    //编辑
    editConditParam(index) {
      console.log('form.videourl', this.form.videoUrl);
      var list = this.conditlist;




      var strList = [];
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        strList.push(item);
      }
      this.conditParam = strList[index];
      this.dialogCondition = true;
    },
    //删除
    delConditParam(index) {
      var list = this.conditlist;
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //执行删除操作
          list = list.splice(index, 1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //移动
    moveConditParam(index) {
      var list = Object.assign([], this.conditlist);
      var temp = list[index];
      var above = index - 1;
      if (above == -1) {
        above = list.length - 1;
      }
      list[index] = list[above];
      list[above] = temp;
      this.conditlist = list;
    },
    // /提交
    submitConditParam(form) {
      var _this = this;
      this.$refs.conditParam.validate((valid) => {
        if (valid) {
          //添加到参数列表
          var index = -1;
          var result = Object.assign({}, _this.conditParam);

          console.log('result:', result);
          console.log('conditlist:', _this.conditlist);
          var list = _this.conditlist;
          for (var i = 0; i < list.length; i++) {
            if (list[i].name == result.name) {
              index = i;
            }
          }
          console.log("index:", index);
          if (index == -1) {
            _this.conditlist.push(result);
          } else if (index != -1) {
            _this.conditlist[index] = result;
          } else {
            _this.conditlist.push(result);
          }

          _this.conditParam = {};
          _this.videolist = [];
          _this.dialogCondition = false;
        } else {
          return false;
        }
      });
    },
  },
  computed: {
    videoUrlsArray() {
      if (this.form && typeof this.form.videoUrl === 'string') {

        return this.form.videoUrl.split(',');
      } else {

        return [];
      }
    }
  },
  watch: {
    videolist: {
      handler: function (newVal, oldVal) {
        // 在数组长度发生变化时触发的逻辑
        console.log('数组长度发生变化');
        // 上传视频
        if ($("#uploadBtn7 input").length == 0) {
          console.log("事件触发");
          $("#uploadBtn7").uploader({
            url: url.getUpload(),
            text: "上传视频",
            type: 'single',
            fileExts: "mp4",
            handleType: "0",
            uploadType: '3',
            oldFileName: '',
            more: false,
            debug: true,
            maxSize: 1024 * 1024 * 1024, //上传文件最大值
            //开始上传验证扩展
            onSuccess: function (data) {
              console.log('data:', data);
              var relativeName1 = data.relativeName; //解决其他js时间中的vue数据同步问题
              _this.videolist.push(data.relativeName);
              console.log('_this.videolist:', _this.videolist);
              //  _this.$set(_this.form, "videoUrl", relativeName1);
            },
          });
        }

        this.updateComponent();

      },
      deep: true
    }
  },
  mounted() {
    //   学校性质
    this.getSchNature();
    // 学校标签
    this.getSchLabelList();
    // 入学时间
    this.getMonthList();
    // 获取日本地区
    this.getJapAreaList();
    // 附近车站下拉
    this.getStationList();
    // 获取语言学校宿舍类型
    this.getSchDormTypeList();
    // 获取语言学校申请条件类型
    this.getSchConditionType();
    //获取服务器列表
    this.getList();
  },
  beforeDestroy() {
    // this.destroyMap();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}

.el-form-item--small.el-form-item {
  margin-right: 0px;
}

.el-button--primary {
  margin-left: 10px;
}

.el-table td {
  border-bottom: none;
}

.el-image-viewer__wrapper {
  z-index: 2065 !important;
}

a {
  text-decoration: none;
  color: inherit;
}

a:hover {
  color: orange;
}

.osm-map {
  height: 500px;
  width: 100%;
  z-index: 1;
}
</style>
